import React from 'react';

import Button from 'components/form/Button.component';

import DropdownMenuFooter from 'clientCommunications/components/Clients/common/DropdownMenuFooter.component';

const AllStylistDropDown = (props) => {
  const { stylists, selectedStylistIds, isStylistOpen } = props;

  const onDone = () => {
    props.onFilterStylist(selectedStylistIds);
    props.closeStylistDropDown();
  };

  const allSelected = stylists.length === selectedStylistIds.length;
  // TODO: update css classes
  return (
    <div data-bem="AllStylistDropDown" className={`drop-down dd-stylist ${isStylistOpen ? '' : 'hidden'} `}>
      <div className="main">
        <div>
          <span className="span-header">Only show clients who have seen</span>
          <ul>
            {stylists
              .filter((c) => c.status === 'active' && c.has_column)
              .map((stylist) => (
                <li key={stylist.id} className="dropdown-item">
                  <label className="clickable-label">
                    <span>{stylist.user_name}</span>
                    <div className="checkbox-box-custom-wrap dd-chk">
                      <input
                        type="checkbox"
                        className="checkbox-box-custom"
                        id={`clints-check-${stylist.id}`}
                        checked={selectedStylistIds && selectedStylistIds.filter((c) => c === stylist.id).length > 0}
                        onChange={() => {
                          props.onSelectStylist(stylist.id);
                        }}
                      />
                      <label className="checkbox-box-label" htmlFor={`clints-check-${stylist.id}`}>
                        <div className="checkbox-box-custom-icon">
                          <span className="ic-sml-18px ic_check_white_18" />
                        </div>
                      </label>
                    </div>
                  </label>
                </li>
              ))}
          </ul>
        </div>
        <div>
          <span className="span-header">Previous staff members:</span>
          <ul>
            {stylists
              .filter((c) => c.status !== 'active')
              .map((stylist) => (
                <li key={stylist.id} className="dropdown-item">
                  <label className="clickable-label">
                    <span>{stylist.user_name}</span>

                    <div className="checkbox-box-custom-wrap dd-chk">
                      <input
                        type="checkbox"
                        className="checkbox-box-custom"
                        id={`clints-check-${stylist.id}`}
                        checked={selectedStylistIds && selectedStylistIds.filter((c) => c === stylist.id).length > 0}
                        onChange={() => {
                          props.onSelectStylist(stylist.id);
                        }}
                      />
                      <label className="checkbox-box-label" htmlFor={`clints-check-${stylist.id}`}>
                        <div className="checkbox-box-custom-icon">
                          <span className="ic-sml-18px ic_check_white_18" />
                        </div>
                      </label>
                    </div>
                  </label>
                </li>
              ))}
          </ul>
        </div>
      </div>
      <DropdownMenuFooter>
        <Button
          variant="slim"
          onClick={() => {
            props.onSelectAllStylists(!allSelected);
          }}
        >
          {allSelected ? 'CLEAR ALL' : 'SELECT ALL'}
        </Button>
        <Button variant="slim" onClick={onDone}>
          DONE
        </Button>
      </DropdownMenuFooter>
    </div>
  );
};

export default AllStylistDropDown;
